// extracted by mini-css-extract-plugin
export default {"ViewPop":"ViewTaskPop_ViewPop__prIe0","mSpinner":"ViewTaskPop_mSpinner__NwXrt"};